<template>
  <v-container fluid>
    <h1 class="headline">{{ $t('pages.expertgains.title') }}</h1>
    <DateIntervalPicker
      v-model="interval"
      class="mb-3">
    </DateIntervalPicker>
    <v-layout row wrap>
      <v-flex xs12 sm4 class="mb-3">
        <dashboard-gains-sum :params="params"></dashboard-gains-sum>
      </v-flex>
      <v-flex xs12 sm8 class="mb-3">
        <dashboard-gains :params="params"></dashboard-gains>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import withInterval from '@/mixins/withInterval'
  import { DashboardGains, DashboardGainsSum } from '@/components/dashboard'
  export default {
    components: {
      DashboardGains,
      DashboardGainsSum
    },
    mixins: [withInterval]
  }
</script>




// WEBPACK FOOTER //
// src/pages/ExpertGains.vue